<template>
  <div>
    <v-dialog v-model="show_dialog_box" max-width="550px">
      <template v-slot:activator="{ on }">
        <v-icon v-on="on" color="dark" class="ms-2">mdi-square-edit-outline</v-icon>
      </template>
      <v-card class="pa-3" color="pop_bg">
        <v-row>
          <v-card-title class="dark--text text-h6 mt-n2 ms-2">Edit Diet Plan</v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="dark" text @click="close"><v-icon>mdi-close</v-icon></v-btn>
        </v-row>
        <v-divider></v-divider>
        <v-card-text>
          <v-container class="mt-2">
            <!-- <h3 class="ms-sm-8">Enter Contact Method Details</h3> -->
            <v-form @submit="updateDietPlan()" v-model="valid" ref="form">
              <v-layout wrap>
                <v-flex xs12 sm5>
                  <h4 class="text-body-2 dark--text">Diet Plan English</h4>
                </v-flex>
                <v-flex xs12 sm7 md6>
                  <v-text-field v-model="dietPlan.nameEn" :rules="[requiredValidator('diet plan')]" solo placeholder="Diet Plan English" dense></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm5>
                  <h4 class="text-body-2 dark--text">Diet Plan Arabic</h4>
                </v-flex>
                <v-flex xs12 sm7 md6>
                  <v-text-field v-model="dietPlan.nameAr" solo placeholder="Diet Plan Arabic" :rules="[requiredValidator('diet plan')]" dense></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm5>
                  <h4 class="text-body-2 dark--text">Currently Active</h4>
                </v-flex>
                <v-flex xs12 sm7 md6>
                  <v-radio-group row v-model="dietPlan.active">
                    <v-radio label="Yes" :value="true"></v-radio>
                    <v-radio label="No" :value="false"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <v-layout wrap>
                <v-flex xs12 sm5>
                  <h4 class="text-body-2 dark--text">Show Order</h4>
                </v-flex>
                <v-flex xs12 sm7 md6>
                  <v-text-field solo dense placeholder="Show Order" v-model="dietPlan.showOrder" @keypress="isNumber" min="0" :rules="[requiredValidator('order')]"></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout wrap class="my-2">
                <v-flex xs12 sm5> </v-flex>
                <v-flex xs12 sm3 md2 class="">
                  <v-img :width="72" class="ms-md-4" :src="getImage()" />
                </v-flex>
              </v-layout>
              <v-layout wrap class="my-2">
                <v-flex xs12 sm5>
                  <h4 class="text-body-2 dark--text">Image</h4>
                </v-flex>

                <v-flex xs12 sm7 md6>
                  <croppa
                    class="mt-2 ml-2"
                    v-model="myCroppa"
                    :width="72"
                    :height="72"
                    canvas-color="dark"
                    :placeholder="'Update'"
                    :placeholder-font-size="16"
                    placeholder-color="yellow"
                    :accept="'image/*'"
                    :file-size-limit="0"
                    :quality="5"
                    :zoom-speed="3"
                    :disabled="false"
                    :disable-drag-and-drop="false"
                    :disable-click-to-choose="false"
                    :disable-drag-to-move="false"
                    :disable-scroll-to-zoom="false"
                    :disable-rotation="false"
                    :prevent-white-space="false"
                    :reverse-scroll-to-zoom="false"
                    :show-remove-button="true"
                    :remove-button-color="'red'"
                    :remove-button-size="20"
                  ></croppa>
                  <v-layout class="mb-2">
                    <span style="color: red" class="text-center">
                      ****Use mouse scroll wheel to crop image****
                    </span>
                  </v-layout>
                  <ImageRequirements type="plan-category" class="mb-2" />
                </v-flex>
              </v-layout>

              <v-layout row justify-end class="mt-5">
                <v-btn :width="$vuetify.breakpoint.smAndUp ? 120 : 90" color="primary" class=" text-capitalize" @click="updateDietPlan()" :loading="btnloading" :disabled="!valid">Save</v-btn>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" timeout="3000" right top color="success">{{ text }}</v-snackbar>
  </div>
</template>

<script>
import { requiredValidator } from "../../../core/methods/validations";
import ImageRequirements from "../../../base-componenents/ImageRequirements.vue";
export default {
  components: {
    ImageRequirements,
  },
  props: {
    dietPlan: {
      required: true,
    },
  },
  data() {
    return {
      requiredValidator: requiredValidator,
      btnloading: false,
      valid: true,
      errors: [],
      snackbar: false,
      text: "",
      show_dialog_box: false,
      image: null,
      imageUrl: process.env.VUE_APP_BASE_URL,
      myCroppa: null,
    };
  },
  methods: {
    getImage() {
      if (this.dietPlan.image) return this.imageUrl + this.dietPlan.image;
      else return "";
    },
    updateDietPlan() {
      if (this.myCroppa.hasImage()) {
        this.myCroppa.generateBlob(blob => {
          this.image = blob;
          this.updateDietPlanAPI();
        });
      } else {
        this.updateDietPlanAPI();
      }
    },
    updateDietPlanAPI() {
      this.btnloading = true;
      this.$apollo
        .mutate({
          mutation: require("../api/updateDietPlan.graphql"),
          variables: {
            id: this.dietPlan._id,
            nameEn: this.dietPlan.nameEn,
            nameAr: this.dietPlan.nameAr,
            active: this.dietPlan.active,
            showOrder: parseInt(this.dietPlan.showOrder),
            image: this.image,
          },
        })
        .then(() => {
          this.btnloading = false;
          this.show_dialog_box = false;
          this.snackbar = true;
          this.text = "Diet Plan Updated";
          this.$root.$emit("updateDietPlan");
        })
        .catch(error => {
          if (error.graphQLErrors != null) {
            console.error(error.graphQLErrors);
          }
          this.btnloading = false;
        });
    },
    close() {
      this.show_dialog_box = false;
    },
  },
};
</script>
